var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_13385",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V48H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_13385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 28L42 6",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0001 6L29.0001 42C28.9124 42.1915 28.7715 42.3537 28.5942 42.4675C28.417 42.5813 28.2108 42.6417 28.0001 42.6417C27.7895 42.6417 27.5833 42.5813 27.406 42.4675C27.2288 42.3537 27.0879 42.1915 27.0001 42L20.0001 28L6.00014 21C5.80866 20.9123 5.64639 20.7714 5.53263 20.5941C5.41887 20.4168 5.3584 20.2106 5.3584 20C5.3584 19.7894 5.41887 19.5832 5.53263 19.4059C5.64639 19.2286 5.80866 19.0877 6.00014 19L42.0001 6Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.ece5e2fb8519e7553b874ce6ced2b551.svg";
export { ForwardRef as ReactComponent };